import { Order, Tier } from '@mc/api'

// Kept out of the module barrel: the state machine imports this.
export const findUpgradeTiers = (tiers: Tier[], order?: Order) => {
  const current = tiers.find(
    (tier) => tier.product.id === order?.products?.[0]?.id,
  )
  const next = current
    ? tiers.find((tier) => tier.hierarchy === current.hierarchy + 1)
    : undefined

  return { current, next }
}

export const isFreeUpgradeTargetEligible = (tiers: Tier[], order?: Order) => {
  const { next } = findUpgradeTiers(tiers, order)

  return (
    !!next &&
    next.product.grantsCertificatePass !== true &&
    next.product.grantsCertificateCredit !== true
  )
}
